import { render, staticRenderFns } from "./pagelayout.vue?vue&type=template&id=72b6d7fa&"
import script from "./pagelayout.vue?vue&type=script&lang=ts&"
export * from "./pagelayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports